import { create } from 'zustand';

/**
 * Live visibility into whether the app can currently reach the API for READS
 * (mirrors usePersistenceStatus, which covers writes). Set by the live-view
 * fetchers: `markOnline` on any successful fetch, `markReconnecting` when a
 * real-app fetch throws. Ephemeral session telemetry, never persisted.
 */
export type ConnectionStatus = 'online' | 'reconnecting';

export interface ConnectionStatusState {
  status: ConnectionStatus;
  markOnline: () => void;
  markReconnecting: () => void;
  reset: () => void;
}

export const useConnectionStatus = create<ConnectionStatusState>((set) => ({
  status: 'online',
  markOnline: () => set({ status: 'online' }),
  markReconnecting: () => set({ status: 'reconnecting' }),
  reset: () => set({ status: 'online' }),
}));
